var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/microphone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/microphone_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 17.8337C14.7583 17.8337 17 15.592 17 12.8337V8.66699C17 5.90866 14.7583 3.66699 12 3.66699C9.24167 3.66699 7 5.90866 7 8.66699V12.8337C7 15.592 9.24167 17.8337 12 17.8337Z",
    stroke: "#0F1653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.5 11.167V12.8337C4.5 16.9753 7.85833 20.3337 12 20.3337C16.1417 20.3337 19.5 16.9753 19.5 12.8337V11.167",
    stroke: "#0F1653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.59375 8.23364C11.0771 7.69198 12.6938 7.69198 14.1771 8.23364",
    stroke: "#0F1653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3594 10.7336C11.3594 10.4586 12.4177 10.4586 13.4177 10.7336",
    stroke: "#0F1653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeries);
export default __webpack_public_path__ + "static/media/series.84a281e69565e432b71fa734eaf83b64.svg";
export { ForwardRef as ReactComponent };